// Core card shell — used by Section, KpiCard, SearchSortControls, and any
// other component that renders a dark bordered rounded card.
export const cardShell = 'bg-gray-900 border border-gray-800 rounded-xl';

// Slightly elevated card (used inside cards, e.g. stat boxes, mini panels)
export const cardInner = 'bg-gray-800 border border-gray-700 rounded-lg';

// Muted inner card with less contrast (e.g. stability/capacity sub-panels in NodeCard)
export const cardSubtle = 'bg-gray-900 border border-gray-800 rounded-lg';
